/* The routine — BEAMUN.
   Adds a step to the cart without leaving the page, so a customer can gather a
   routine in one parcel. */

(function () {
  var root = document.querySelector('.bm-routine');
  if (!root) return;

  var status = root.querySelector('[data-routine-status]');

  function say(message) {
    if (status) status.textContent = message;
  }

  function refreshCartCount() {
    /* Nudge the theme's own cart drawer and bubble if it is listening. */
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  root.addEventListener('click', function (event) {
    var button = event.target.closest('[data-routine-add]');
    if (!button || button.disabled) return;

    var id = parseInt(button.getAttribute('data-variant-id'), 10);
    var title = button.getAttribute('data-title') || 'That';
    var original = button.textContent;

    button.disabled = true;
    button.textContent = 'Adding';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error(body.description || body.message || 'It could not be added.');
          return body;
        });
      })
      .then(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        button.textContent = 'Added';
        var count = cart.item_count;
        say(title + ' is in your bag. ' + (count === 1 ? '1 item' : count + ' items') + ' so far.');
        refreshCartCount();
      })
      .catch(function (err) {
        button.disabled = false;
        button.textContent = original;
        say(err.message || 'Something went wrong adding that.');
      });
  });
})();
